import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';

import { withTranslation } from 'react-i18next';

import Row from 'reactstrap/lib/Row';
import Col from 'reactstrap/lib/Col';
import Media from 'reactstrap/lib/Media';
import Button from 'reactstrap/lib/Button';
import Modal from 'reactstrap/lib/Modal';
import ModalHeader from 'reactstrap/lib/ModalHeader';
import ModalBody from 'reactstrap/lib/ModalBody';
import ModalFooter from 'reactstrap/lib/ModalFooter';

import Gift from './Gift';

import giftImg from '../../../images/Game/gift.svg';
import closeImg from '../../../images/icons/close.png';

// import defaultImage from '../../../images/Game/defaultImage.webp';
import coinImg from '../../../images/coin.svg';
import {
  FONT_MODE,
  GIFTS_ITEMS,
  GIFTS_TAB,
  SCREENS,
} from '../../../constants/constants';
import { UncontrolledTooltip } from 'reactstrap';
import { setUserScreenViewNew } from '../../../actions/member';

class SendGift extends Component {
  static propTypes = {
    sendGift: PropTypes.func.isRequired,
    //  toggle: PropTypes.func.isRequired,
    playButtonSound: PropTypes.func.isRequired,
    toggle: PropTypes.func.isRequired,
    t: PropTypes.func.isRequired,
    gifts: PropTypes.shape(),
    drinkGifts: PropTypes.shape(),
    notificationSettings: PropTypes.shape(),
    modalOpen: PropTypes.bool,
    isFullscreen: PropTypes.bool,
    roomId: PropTypes.string,
    giftPlayerUid: PropTypes.string,
    fontMode: PropTypes.string,
    popularGifts: PropTypes.shape({}),
    tournamentRoom: PropTypes.bool,
    disableDrinkGifts: PropTypes.bool,
  }

  static defaultProps = {
    gifts: {},
    notificationSettings: {},
    modalOpen: false,
    isFullscreen: false,
    roomId: null,
    giftPlayerUid: null,
    fontMode: FONT_MODE.normal,
    popularGifts: {},
    disableDrinkGifts: false,
  }

  constructor(props) {
    super(props);
    this.state = {
      giftId: '',
      sendingGift: false,
      activeItem: 'popular',
    };
  }

  componentDidUpdate(prevProps) {
    const { setScreenViewNew } = this.props;
    if (this.props.modalOpen && !prevProps.modalOpen) {
      setScreenViewNew(SCREENS.ACTIVE_ROOM.GIFTS);
    }
  }

  sendGift = (giftId, drink) => {
    const {
      sendGift, roomId, playButtonSound, giftPlayerUid,
    } = this.props;
    const {
      sendingGift,
    } = this.state;

    this.setState({ confirmationModal: false });

    if (!sendingGift && giftPlayerUid && giftId) {
      playButtonSound();

      this.setState({ sendingGift: true });
      sendGift(roomId, giftId, [giftPlayerUid], drink).then((res) => {
        if (res === 'success') {
          this.closeModal();
        }
        this.setState({ sendingGift: false });
      }).catch(() => {
        this.setState({ sendingGift: false });
      });
    }
  }

  closeModal = () => {
    const { toggle } = this.props;

    this.setState({
      giftId: '',
    });

    toggle(null, false);
  }

  startSendingGift = (giftId, drink) => {
    const { notificationSettings, playButtonSound } = this.props;
    playButtonSound();

    if (notificationSettings && notificationSettings.purchaseGift === false) {
      this.sendGift(giftId, drink);
    } else {
      this.setState({ giftId, drink });
      this.toggleConfirmModal(giftId, drink);
    }
  }

  toggleConfirmModal = (key, drink) => {
    const { gifts, drinkGifts } = this.props;
    const gift = drink ? drinkGifts[key] : gifts[key];

    this.setState(prevState => ({ 
      confirmationModal: !prevState.confirmationModal,
      totalPrice: gift?.price,
    }));
  }

  updateScrollPos = (val) => {
    this.setState({ scrollPos: val.topPosition || 0 });
  }

  scroll = (newVal) => {
    this.giftsScrollbar.scrollYTo(newVal);
  }

  toggleActiveItem = (gift) => {
    const { activeItem } = this.state;

    if (gift === activeItem) return;

    this.setState({
      activeItem: gift
    })
  }

  render() {
    const {
      gifts,
      drinkGifts,
      t,
      modalOpen,
      playButtonSound,
      isFullscreen,
      fontMode,
      popularGifts,
      tournamentRoom,
      disableDrinkGifts,
    } = this.props;

    const {
      giftId,
      drink,
      confirmationModal,
      totalPrice,
      activeItem,
    } = this.state;

    return (
      <div>
        <Modal container={'div > div'} size="lg" isOpen={modalOpen} toggle={this.closeModal} className={`notification gift-modal old-modal ${isFullscreen ? 'gift-modal-fullscreen' : ''} root-font-${fontMode}`}>
          <ModalHeader
            toggle={() => { playButtonSound(); this.closeModal(); }}
            className="notification-header"
            close={
              <Media src={closeImg} className="notification-header-close" alt="X" onClick={() => { playButtonSound(); this.closeModal(); }} />
            }
          >
            <Media src={giftImg} />
            {' '}
            {t('gifts.gifts')}
          </ModalHeader>
          <ModalBody className="notification-body">
            <Row className='mb-2'>
              <Col>
                {t('gifts.buyAnyGift')}
                <Media style={{ display: 'inline-block', width: 22, height: 22 }} src={coinImg} />
              </Col>
            </Row>
            <Row>
              <div className='d-flex flex-row no-wrap w-full justify-between px-3 gap-2'>
                {GIFTS_TAB.map((item, idx) => (
                  <div key={idx} className={`d-flex align-items-center px-2 py-2 gift-tab-button ${activeItem === item && 'gift-tab-button-active'}`} onClick={() => this.toggleActiveItem(item)}>
                    <span className='w-full'>{t(`gifts.${item}`)}</span>
                  </div>
                ))}
              </div>
            </Row>

            <Row>
              <>
                {activeItem === 'popular' ? (
                  <div style={{ maxWidth: '100%', width: '100%', padding: '15px' }}>
                    {popularGifts && Object.keys(popularGifts).map(key => (
                      <Fragment key={key}>
                        <Gift
                          id={key}
                          altClassName="float-left"
                          giftId={giftId}
                          gift={popularGifts[key]}
                          selectGift={() => this.startSendingGift(key)}
                          isFullscreen={isFullscreen}
                        />
                      </Fragment>
                    ))}
                  </div>
                ) : (
                  <div style={{ maxWidth: '100%', width: '100%', padding: '15px' }}>

                    {GIFTS_ITEMS[activeItem] && GIFTS_ITEMS[activeItem].map((item, key) => {
                      if (!gifts[item]) return;

                      return (
                        <Fragment key={key}>
                          <Gift
                            id={gifts[item].name}
                            altClassName="float-left"
                            giftId={giftId}
                            drink={drink}
                            gift={gifts[item]}
                            selectGift={() => this.startSendingGift(gifts[item].name)}
                            isFullscreen={isFullscreen}
                          />
                        </Fragment>
                      )
                    })}
                    {activeItem === 'foodAndDrinks' && drinkGifts && !disableDrinkGifts && !tournamentRoom && Object.keys(drinkGifts).map(key => (
                      <Fragment key={key}>
                        <Gift
                          id={key}
                          popoverId={`drink-${key}`}
                          altClassName="float-left"
                          giftId={giftId}
                          drink={drink}
                          gift={drinkGifts[key]}
                          selectGift={() => this.startSendingGift(key, true)}
                          isFullscreen={isFullscreen}
                          isDrinkGift={true}
                        />
                        <UncontrolledTooltip
                          className="giftsHistory-tooltip player-receivedGift-tooltip-old player-receivedGift-tooltip-old-player-modal-right"
                          placement="top"
                          target={`drink-${key}`}
                          container={'div > div'}
                        >
                          {t('gifts.serveDrink')}
                        </UncontrolledTooltip>
                      </Fragment>
                    ))}
                  </div>
                )}
              </>
            </Row>
          </ModalBody>
        </Modal>

        <Modal container={'div > div'} isOpen={confirmationModal} toggle={this.toggleConfirmModal} className={`notification gifts-send-confirmation root-font-${fontMode}`}>
          <ModalHeader
            toggle={this.toggleConfirmModal}
            className="notification-header"
            close={
              <Media src={closeImg} className="notification-header-close" alt="X" onClick={this.toggleConfirmModal} />
            }
          >{t('home.confirm')}</ModalHeader>
          <ModalBody className="notification-body">
            {`${t('gifts.confirmation')} ${totalPrice} ${t('gifts.coins')}­ `}
          </ModalBody>
          <ModalFooter className="notification-footer">
            <Button className="btn notification-footer-button" onClick={() => this.sendGift(giftId, drink)}>
              {t('common.yes')}
            </Button>
            <Button type="button" className="btn notification-footer-button" onClick={this.toggleConfirmModal}>
              {t('common.no')}
            </Button>
          </ModalFooter>
        </Modal>
      </div>
    );
  }
}


const mapStateToProps = state => ({
  gifts: state.rooms.gifts || {},
  drinkGifts: state.rooms.drinkGifts || {},
  popularGifts: state.rooms.popularGifts || {},
});

const mapDispatchToProps = {
  setScreenViewNew: setUserScreenViewNew,
};

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation('common', 'gifts')(SendGift));
